import React, { memo, useContext, useEffect, useState } from 'react';
import { Table, ActionIcon, Select, Pagination, LoadingOverlay } from '@mantine/core';
import { IoTrashOutline } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import classes from "./TransportDataTable.module.css";
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../Customhooks/useFetch';
import { baseUrl } from '../../../Constants/constant';
import DeleterowData from '../../../CustomComponent/DeleteTableRow/DeleteTableRow.component';
import { useDisclosure } from '@mantine/hooks';
import { authContext } from '../../../context/AuthProvider.component';

const transportTypes: any = {
  1: 'Land',
  2: 'Air',
  3: 'Sea',
};

function TransportDataTable({ editLink, search }: any) {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [refresh, setRefresh] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [confirmDeleteOpened, { open: openConfirmDelete, close: closeConfirmDelete }] = useDisclosure(false);
  const [successModalOpened, { open: openSuccessModal, close: closeSuccessModal }] = useDisclosure(false);

  const navigate = useNavigate();
  const { setError, inputRefresh }: any = useContext(authContext);

  const token = localStorage.getItem("token");

  const {
    data: datalist,
    loading: listLoading,
    error: getlistError,
    fetchData: gettable,
  } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });

  useEffect(() => {
    gettable(`${baseUrl}admin/transports?page=${page}&limit=${limit}&search=${search}`);
  }, [page, limit, search, refresh]);
  useEffect(() => {
    if (getlistError) {
      setError(getlistError?.message)
    }
  }, [getlistError]);
    useEffect(() => {
      if (inputRefresh > 0) {
        setRefresh(inputRefresh);
      }
    }, [inputRefresh]);

  const handleClickEdit = (id: number) => {
    navigate(`${editLink}/${id}`);
  };
  const handleClickDelete = async (id: number) => {
    setSelectedId(id);
    openConfirmDelete();
  };
  const handleCloseSuccessModal = () => {
    setRefresh(prev =>  prev + 1);
    closeSuccessModal();
  };
  const rows = datalist?.data?.rows?.map((el: any) => (
    <Table.Tr key={el.id}>
      <Table.Td>{el.transport_name}</Table.Td>
      <Table.Td>{transportTypes[el.transport_type] || 'Not Filled'}</Table.Td>
      <Table.Td>{el.co2_embodiment} / km</Table.Td>
      <Table.Td>{el.source_name || 'N/A'}</Table.Td>
      <Table.Td>
        <ActionIcon
          color="#404040"
          variant="subtle"
          onClick={() => handleClickEdit(el.id)}
        >
          <FaRegEdit size={16} />
        </ActionIcon>
        <ActionIcon
          color="red"
          variant="subtle"
          onClick={() => handleClickDelete(el.id)}
        >
          <IoTrashOutline size={16} />
        </ActionIcon>
      </Table.Td>
    </Table.Tr>
  ));

  const totalPages = Math.ceil((datalist?.data?.count || 0) / limit);
  return (
    <div >
      <LoadingOverlay
        visible={listLoading}
        zIndex={1000}
        overlayProps={{
          radius: 'sm',
          blur: 2,
          style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }
        }}
        loaderProps={{ color: '#404040', type: 'bars' }}
      />

      {/* Error State */}
      {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>}

      {!listLoading && !getlistError && (
        <>
          {/* Table */}
          <Table striped className={classes.customtable} mt={18}>
            <Table.Thead>
              <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                <Table.Th>Transport Type</Table.Th>
                <Table.Th>Shipment Mode</Table.Th>
                <Table.Th>Per km CO₂ E</Table.Th>
                <Table.Th>Source</Table.Th>
                <Table.Th>Action</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {datalist?.data?.rows?.length < 1 ? (
                <Table.Tr>
                  <Table.Td colSpan={3} style={{ textAlign: 'center', fontSize: '17px' }}>No data Available </Table.Td>
                </Table.Tr>
              ) : (
                rows
              )}
            </Table.Tbody>
          </Table>

          {/* Pagination */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginTop: '20px',
            }}
          >
            <Select
              data={[
                { value: '5', label: '05 per page' },
                { value: '10', label: '10 per page' },
                { value: '20', label: '20 per page' },
              ]}
              value={limit.toString()}
              onChange={(value) => setLimit(Number(value))}
              style={{ width: '150px' }}
            />
            <Pagination
              total={totalPages}
              value={page}
              onChange={setPage}
              color="#404040"
            />
          </div>
        </>
      )}
      <DeleterowData
        isConfirmOpen={confirmDeleteOpened}
        isSuccessOpen={successModalOpened}
        closeConfirm={closeConfirmDelete}
        closeSuccess={handleCloseSuccessModal}
        selectedId={selectedId}
        onDeleteSuccess={openSuccessModal}
        url={'admin/transports/delete/'}
      />
    </div>
  );
}

export default memo(TransportDataTable);

